import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/icons/icon-lamp.svg'


const _hoisted_1 = {
  key: 0,
  class: "animation-wr"
}
const _hoisted_2 = {
  key: 0,
  class: "content-instructions-facade"
}
const _hoisted_3 = {
  key: 1,
  class: "slider-wr"
}
const _hoisted_4 = { class: "house-slider-options-content" }
const _hoisted_5 = { class: "house-slider-options" }
const _hoisted_6 = { class: "content-carousel mobile" }
const _hoisted_7 = {
  key: 2,
  class: "content-img-selection"
}
const _hoisted_8 = { class: "content-carousel" }
const _hoisted_9 = { class: "content-slider" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return ($setup.props.selectedHouseDesign)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        ($setup.isDesktop)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [...(_cache[0] || (_cache[0] = [
              _createStaticVNode("<div class=\"content-logo\" data-v-4415f1d4><img class=\"icon-lamp\" src=\"" + _imports_0 + "\" data-v-4415f1d4></div><div class=\"content-text\" data-v-4415f1d4><span class=\"tex-instructions bold\" data-v-4415f1d4>Exterior Facade </span><span class=\"tex-instructions\" data-v-4415f1d4>refers to the exterior design style of your home. In some cases, the same home design will have multiple facade choices for you to select the finished appearance of your home.</span></div>", 2)
            ]))]))
          : _createCommentVNode("", true),
        (!$setup.isDesktop)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createVNode($setup["BuilderSliderButtons"], {
                    class: "builder-slider-buttons",
                    items: $setup.facadesFormatted,
                    selectedItem: $setup.selectedFormattedFacade,
                    title: $setup.isDesktop ? 'Step 04 : ' : '',
                    contentTitle: $setup.isDesktop ? 'Select Exterior' : 'Swipe to compare facade styles',
                    isLogoSwipe: true,
                    onOnSelectItem: $setup.onSelectFacade
                  }, null, 8, ["items", "selectedItem", "title", "contentTitle"])
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _createVNode($setup["CustomizeHouseSlider"], {
                    sliderImages: $setup.sliderImages,
                    showArrows: false
                  }, null, 8, ["sliderImages"])
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        ($setup.isDesktop)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createVNode($setup["CustomizeHouseSlider"], {
                  sliderImages: $setup.sliderImages,
                  showArrows: false
                }, null, 8, ["sliderImages"])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _cache[1] || (_cache[1] = _createElementVNode("span", { class: "title-facade" }, "Facade options:", -1)),
                _createVNode($setup["BuilderSliderImages"], {
                  images: $setup.facadesFormatted,
                  selectedimage: $setup.selectedFormattedFacade,
                  onOnSelectImage: $setup.onSelectFacade,
                  isSelectFacade: true
                }, null, 8, ["images", "selectedimage"])
              ])
            ]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}